// EKIP Holding — Bilingual translations FR/EN
// Structured per page/component for maintainability

export const translations = {
  fr: {
    nav: {
      groupe: "Groupe",
      ecosysteme: "Écosystème",
      projets: "Projets",
      impact: "Impact",
      actualites: "Actualités",
      carrieres: "Carrières",
      contact: "Contact",
      cta: "Nous contacter",
    },
    common: {
      discover: "Découvrir",
      learnMore: "En savoir plus",
      readMore: "Lire la suite",
      seeAll: "Tout voir",
      back: "Retour",
      loading: "Chargement…",
      required: "Requis",
      submit: "Envoyer",
      submitting: "Envoi en cours…",
      success: "Message envoyé avec succès.",
      error: "Une erreur est survenue. Réessayez.",
      allProjects: "Tous les projets",
      allNews: "Toutes les actualités",
      slogan: "Ensemble, vivons mieux.",
    },
    home: {
      hero: {
        overline: "EKIP HOLDING COMPANY",
        title1: "Bâtir l'écosystème intégré",
        title2: "de vie moderne en Afrique",
        subtitle: "Immobilier • Énergie • Technologie • Paiements — Un réseau, une expérience, un avenir.",
        ctaPrimary: "Découvrir l'écosystème",
        ctaSecondary: "Voir nos projets",
        scroll: "Défiler",
      },
      stats: {
        eyebrow: "Notre empreinte",
        title: "Une ambition mesurable.",
        items: [
          { value: 60000, suffix: "", label: "Logements planifiés (Vision 2035)" },
          { value: 100, suffix: "", label: "Stations Wayne en déploiement" },
          { value: 8, suffix: "", label: "Pôles urbains" },
          { value: 300000, suffix: "", label: "Personnes logées à terme" },
        ],
      },
      ecosystem: {
        eyebrow: "01 — Écosystème",
        title: "Quatre métiers.",
        titleItalic: "Un même réseau.",
        subtitle: "Chaque filiale alimente les autres — les synergies créent une expérience client unifiée.",
        cta: "Explorer l'écosystème",
      },
      projects: {
        eyebrow: "02 — Projets structurants",
        title: "Les chantiers qui",
        titleItalic: "façonnent la Côte d'Ivoire.",
        cta: "Voir tous les projets",
      },
      quote: {
        eyebrow: "Mot du Président",
        text: "Notre ambition est de créer en Côte d'Ivoire le premier écosystème où l'habitat, l'énergie et la technologie convergent pour transformer le quotidien de millions de personnes.",
        author: "Ouagnimin SORHO",
        role: "Président-Directeur Général",
      },
      news: {
        eyebrow: "03 — Actualités",
        title: "Nos dernières publications.",
      },
      partners: {
        eyebrow: "Partenaires & alliances",
        title: "Ils bâtissent l'écosystème avec nous.",
      },
    },
    groupe: {
      hero: {
        overline: "Le groupe",
        title: "Un groupe bâti pour",
        titleItalic: "l'Afrique de demain.",
        subtitle: "La vision, les valeurs et la gouvernance d'EKIP Holding Company.",
      },
      vision: {
        eyebrow: "01 — Vision & Mission",
        visionLabel: "Vision",
        visionText: "Bâtir l'écosystème intégré de vie moderne en Afrique, où chaque besoin quotidien trouve sa solution dans un réseau interconnecté et intelligent.",
        missionLabel: "Mission",
        missionText: "Développer des solutions innovantes et durables qui transforment la manière dont les Ivoiriens vivent, se déplacent et consomment, en créant des synergies entre l'immobilier résidentiel, la distribution énergétique et les technologies connectées.",
      },
      history: {
        eyebrow: "02 — Notre histoire",
        title: "Une trajectoire",
        titleItalic: "construite dans la durée.",
        items: [
          { year: "2018", title: "Création d'EKIP", desc: "Fondation du groupe autour d'une conviction : l'intégration créera plus de valeur que la spécialisation." },
          { year: "2020", title: "Premières acquisitions foncières", desc: "Constitution de la réserve foncière du programme Vision 2035 sur 8 pôles urbains stratégiques." },
          { year: "2022", title: "Partenariat Wayne Technologies", desc: "Accord d'exclusivité pour le déploiement de 100 stations Wayne en Côte d'Ivoire." },
          { year: "2023", title: "Lancement Vision 2035", desc: "Démarrage opérationnel du programme national d'habitat intégré." },
          { year: "2024", title: "Création d'EKIPTECH & KIPAY", desc: "Structuration des filiales technologique et paiements pour compléter l'écosystème." },
          { year: "2026", title: "Structuration EKIP Capital", desc: "Mise en place de la plateforme de gestion d'actifs (agrément AMF-UMOA en cours)." },
        ],
      },
      governance: {
        eyebrow: "03 — Gouvernance",
        title: "Une équipe engagée,",
        titleItalic: "des principes clairs.",
        team: [
          { name: "Ouagnimin SORHO", role: "Président-Directeur Général", bio: "Fondateur et architecte stratégique d'EKIP Holding Company. Vision panafricaine et exécution rigoureuse." },
          { name: "Direction Financière", role: "CFO Groupe", bio: "Structuration des SPV, relation investisseurs et discipline capitalistique." },
          { name: "Direction Opérations", role: "COO Groupe", bio: "Coordination des filiales, exécution des projets structurants et synergies inter-métiers." },
          { name: "Direction Technique", role: "CTO Groupe", bio: "Innovation constructive, technologies connectées et plateforme d'écosystème." },
        ],
        principles: [
          { title: "Séparation des pouvoirs", desc: "Gouvernance claire entre actionnaires, conseil et direction." },
          { title: "Transparence & Intégrité", desc: "Reporting institutionnel, éthique non négociable." },
          { title: "Protection des minoritaires", desc: "Structuration juridique protégeant tous les investisseurs." },
          { title: "Conformité OHADA", desc: "Alignement complet sur les standards juridiques régionaux." },
        ],
      },
      figures: {
        eyebrow: "04 — Chiffres clés",
        title: "La mesure",
        titleItalic: "de notre ambition.",
        items: [
          { value: 5, suffix: "", label: "Filiales opérationnelles" },
          { value: 4, suffix: "", label: "Projets structurants" },
          { value: 1000, suffix: "+", label: "Emplois projetés à 2030" },
          { value: 8, suffix: "", label: "Pôles urbains" },
        ],
      },
    },
    ecosysteme: {
      hero: {
        overline: "Écosystème",
        title: "L'écosystème intégré",
        titleItalic: "de vie moderne.",
        subtitle: "Quatre métiers. Un réseau. Une expérience client unifiée.",
      },
      schema: {
        eyebrow: "01 — Schéma d'écosystème",
        title: "Cliquez sur une filiale",
        titleItalic: "pour révéler ses synergies.",
        holdingLabel: "Holding",
        synergyLabel: "Synergie",
      },
      synergies: {
        title: "Six synergies concrètes.",
        items: [
          { from: "KIDH", to: "Kip Energy", desc: "Stations Wayne intégrées aux quartiers KIDH." },
          { from: "KIDH", to: "EKIPTECH", desc: "Smart buildings, IoT et domotique résidentielle." },
          { from: "KIDH", to: "KIPAY", desc: "Paiement cashless et crédit immobilier co-brandé." },
          { from: "Kip Energy", to: "EKIPTECH", desc: "Boutiques tech intégrées en stations Wayne." },
          { from: "Kip Energy", to: "KIPAY", desc: "Paiement digital carburant et lubrifiants." },
          { from: "EKIPTECH", to: "KIPAY", desc: "Solutions connectées de paiement IoT." },
        ],
      },
    },
    projets: {
      hero: {
        overline: "Projets structurants",
        title: "Des projets qui",
        titleItalic: "transforment la Côte d'Ivoire.",
        subtitle: "Infrastructure, habitat, tourisme — les chantiers qui façonnent l'avenir.",
      },
      map: {
        eyebrow: "01 — Cartographie",
        title: "Une présence",
        titleItalic: "à l'échelle nationale.",
        legend: {
          immobilier: "Immobilier",
          energie: "Énergie",
          tourisme: "Tourisme",
          infrastructure: "Infrastructure",
        },
      },
      list: {
        eyebrow: "02 — Projets phares",
        title: "Quatre chantiers,",
        titleItalic: "une même ambition.",
      },
      cta: {
        title: "Rejoignez ces projets structurants.",
        subtitle: "Investisseurs institutionnels, partenaires stratégiques ou institutions publiques : entrons en discussion.",
        button: "Devenir partenaire",
      },
    },
    impact: {
      hero: {
        overline: "Impact",
        title: "L'impact,",
        titleItalic: "au-delà des chiffres.",
        subtitle: "Emplois créés, logements accessibles, énergie déployée, communautés servies.",
      },
      stats: {
        eyebrow: "01 — Impact social & économique",
        title: "Une contribution",
        titleItalic: "tangible.",
        items: [
          { value: 1000, suffix: "+", label: "Emplois projetés à 2030" },
          { value: 60000, suffix: "", label: "Logements planifiés" },
          { value: 100, suffix: "", label: "Stations Wayne" },
          { value: 8, suffix: "", label: "Pôles urbains" },
          { value: 300000, suffix: "", label: "Personnes logées à terme" },
          { value: 47000, suffix: "", label: "Emplois Vision 2035" },
        ],
      },
      odd: {
        eyebrow: "02 — Objectifs de Développement Durable",
        title: "Alignés sur",
        titleItalic: "les ODD des Nations Unies.",
        items: [
          { code: "ODD 7", title: "Énergie propre et d'un coût abordable" },
          { code: "ODD 8", title: "Travail décent et croissance économique" },
          { code: "ODD 9", title: "Industrie, innovation et infrastructure" },
          { code: "ODD 11", title: "Villes et communautés durables" },
          { code: "ODD 17", title: "Partenariats pour la réalisation des objectifs" },
        ],
      },
      innovation: {
        eyebrow: "03 — Innovation constructive",
        title: "Construire",
        titleItalic: "mieux, plus vite, plus juste.",
        text: "Notre approche technique — EPS panels, tunnel formwork, light steel framing — permet une réduction de 33 à 40% des coûts de construction par rapport aux méthodes traditionnelles. Un impact direct sur l'accessibilité du logement en Côte d'Ivoire.",
        stats: [
          { value: 40, suffix: "%", label: "Réduction des coûts vs méthodes traditionnelles" },
          { value: 3, suffix: "x", label: "Vitesse de construction accélérée" },
          { value: 100, suffix: "%", label: "Conforme normes internationales" },
        ],
      },
      territorial: {
        eyebrow: "04 — Engagement territorial",
        title: "Ancrés",
        titleItalic: "dans les communautés locales.",
        items: [
          { title: "Chefferies traditionnelles", desc: "Concertations systématiques avec les autorités coutumières avant tout projet." },
          { title: "Formation professionnelle", desc: "Programmes de qualification aux métiers du bâtiment, de l'énergie et du digital." },
          { title: "Sous-traitance locale", desc: "Priorité aux PME ivoiriennes pour l'exécution des chantiers." },
        ],
      },
    },
    actualites: {
      hero: {
        overline: "Actualités",
        title: "Nos communiqués,",
        titleItalic: "publications et événements.",
      },
      categories: {
        all: "Toutes",
        communique: "Communiqués",
        media: "Médias",
        evenement: "Événements",
        publication: "Publications",
      },
      empty: "Aucune actualité pour le moment.",
    },
    carrieres: {
      hero: {
        overline: "Carrières",
        title: "Rejoignez ceux qui",
        titleItalic: "construisent l'Afrique de demain.",
        subtitle: "Nous recrutons les talents qui feront grandir EKIP Holding et ses filiales.",
      },
      why: {
        eyebrow: "01 — Pourquoi EKIP",
        title: "Un employeur",
        titleItalic: "à la hauteur de vos ambitions.",
        pillars: [
          { title: "Projets d'envergure continentale", desc: "Participez à des chantiers structurants pour la Côte d'Ivoire et l'Afrique de l'Ouest." },
          { title: "Croissance exponentielle", desc: "De 25 à 650 collaborateurs projetés d'ici 2030 — perspectives d'évolution rapides." },
          { title: "Formation internationale", desc: "Programmes de développement en partenariat avec des groupes africains et internationaux." },
          { title: "Projets phares du continent", desc: "Vision 2035, Réseau Wayne, Sassandra Resort — travaillez sur les projets qui comptent." },
        ],
      },
      offers: {
        eyebrow: "02 — Offres en cours",
        title: "Postes",
        titleItalic: "à pourvoir.",
        filterEntity: "Filiale",
        filterType: "Type",
        all: "Toutes",
        apply: "Postuler",
        items: [
          { title: "Directeur Général KIDH", entity: "KIDH", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Head of Stations Network", entity: "Kip Energy", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Lead Product Manager IoT", entity: "EKIPTECH", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Growth Manager Wallet", entity: "KIPAY", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Analyst Corporate Finance", entity: "EKIP Capital", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Chef de projet Construction", entity: "KIDH", location: "Grand-Bassam", type: "CDD", date: "Dec. 2026" },
        ],
      },
      spontaneous: {
        eyebrow: "03 — Candidature spontanée",
        title: "Votre talent",
        titleItalic: "nous intéresse.",
        subtitle: "Envoyez-nous votre profil, même sans offre correspondant à votre expertise.",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email professionnel",
        phone: "Téléphone",
        subsidiary: "Filiale d'intérêt",
        cvLabel: "CV (PDF)",
        cvChoose: "Choisir un fichier",
        motivation: "Lettre de motivation",
        submit: "Envoyer ma candidature",
      },
    },
    contact: {
      hero: {
        overline: "Contact",
        title: "Parlons de",
        titleItalic: "vos ambitions.",
        subtitle: "Investisseurs, partenaires, institutions ou médias — nos équipes vous répondent sous 48h.",
      },
      general: {
        eyebrow: "01 — Formulaire général",
        title: "Écrivez-nous.",
        name: "Nom complet",
        email: "Email",
        subject: "Objet",
        subjects: [
          "Information générale",
          "Partenariat",
          "Investissement",
          "Presse",
          "Recrutement",
          "Autre",
        ],
        message: "Votre message",
      },
      investors: {
        eyebrow: "02 — Relations investisseurs",
        title: "Un contact",
        titleItalic: "dédié aux institutions.",
        subtitle: "IFC, Proparco, BOAD, AfDB, family offices, fonds souverains — un guichet unique.",
        organization: "Organisation",
        role: "Fonction",
        investorType: "Type d'investisseur",
        types: ["DFI", "Fonds d'investissement", "Family office", "Fonds souverain", "Banque", "Autre"],
        note: "Message",
      },
      coords: {
        eyebrow: "03 — Coordonnées",
        title: "Nous rendre visite.",
        addressLabel: "Siège social",
        address: ["Rue K104, Blvd Latrille", "Cocody II Plateaux", "Abidjan, Côte d'Ivoire"],
        emailLabel: "Email",
        emails: ["contact@ekipholding.ci", "investors@ekipholding.ci"],
        phoneLabel: "Téléphone",
        phones: ["+225 27 22 41 25 25", "+225 05 06 06 55 06"],
      },
    },
    footer: {
      about: "EKIP Holding Company — un écosystème opérationnel intégré basé à Abidjan, Côte d'Ivoire.",
      columns: {
        group: "Groupe",
        ecosystem: "Écosystème",
        projects: "Projets",
        contact: "Contact",
      },
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      sitemap: "Plan du site",
      copyright: "© 2026 EKIP Holding Company. Tous droits réservés.",
      newsletter: "Recevez nos communiqués institutionnels.",
      newsletterCta: "S'abonner",
    },
  },
  en: {
    nav: {
      groupe: "Group",
      ecosysteme: "Ecosystem",
      projets: "Projects",
      impact: "Impact",
      actualites: "News",
      carrieres: "Careers",
      contact: "Contact",
      cta: "Get in touch",
    },
    common: {
      discover: "Discover",
      learnMore: "Learn more",
      readMore: "Read more",
      seeAll: "See all",
      back: "Back",
      loading: "Loading…",
      required: "Required",
      submit: "Send",
      submitting: "Sending…",
      success: "Message sent successfully.",
      error: "An error occurred. Please try again.",
      allProjects: "All projects",
      allNews: "All news",
      slogan: "Together, we live better.",
    },
    home: {
      hero: {
        overline: "EKIP HOLDING COMPANY",
        title1: "Building the integrated ecosystem",
        title2: "of modern life in Africa",
        subtitle: "Real Estate • Energy • Technology • Payments — One network, one experience, one future.",
        ctaPrimary: "Discover the ecosystem",
        ctaSecondary: "See our projects",
        scroll: "Scroll",
      },
      stats: {
        eyebrow: "Our footprint",
        title: "A measurable ambition.",
        items: [
          { value: 60000, suffix: "", label: "Homes planned (Vision 2035)" },
          { value: 100, suffix: "", label: "Wayne stations deploying" },
          { value: 8, suffix: "", label: "Urban hubs" },
          { value: 300000, suffix: "", label: "People housed at scale" },
        ],
      },
      ecosystem: {
        eyebrow: "01 — Ecosystem",
        title: "Four businesses.",
        titleItalic: "One network.",
        subtitle: "Each subsidiary powers the others — synergies create a unified client experience.",
        cta: "Explore the ecosystem",
      },
      projects: {
        eyebrow: "02 — Structuring projects",
        title: "The developments",
        titleItalic: "shaping Côte d'Ivoire.",
        cta: "See all projects",
      },
      quote: {
        eyebrow: "Chairman's message",
        text: "Our ambition is to create in Côte d'Ivoire the first ecosystem where housing, energy and technology converge to transform the daily lives of millions.",
        author: "Ouagnimin SORHO",
        role: "Chairman & CEO",
      },
      news: {
        eyebrow: "03 — News",
        title: "Our latest publications.",
      },
      partners: {
        eyebrow: "Partners & alliances",
        title: "Building the ecosystem with us.",
      },
    },
    groupe: {
      hero: {
        overline: "The group",
        title: "A group built for",
        titleItalic: "tomorrow's Africa.",
        subtitle: "Vision, values and governance of EKIP Holding Company.",
      },
      vision: {
        eyebrow: "01 — Vision & Mission",
        visionLabel: "Vision",
        visionText: "Build the integrated ecosystem of modern life in Africa, where every daily need finds its solution in an interconnected, intelligent network.",
        missionLabel: "Mission",
        missionText: "Develop innovative and sustainable solutions that transform how Ivorians live, move and consume, by creating synergies between residential real estate, energy distribution and connected technologies.",
      },
      history: {
        eyebrow: "02 — Our history",
        title: "A trajectory",
        titleItalic: "built for the long run.",
        items: [
          { year: "2018", title: "EKIP is founded", desc: "The group is founded on a conviction: integration creates more value than specialization." },
          { year: "2020", title: "First land acquisitions", desc: "Building the land reserve for Vision 2035 across 8 strategic urban hubs." },
          { year: "2022", title: "Wayne Technologies partnership", desc: "Exclusive agreement to deploy 100 Wayne stations in Côte d'Ivoire." },
          { year: "2023", title: "Vision 2035 launched", desc: "Operational start of the national integrated housing program." },
          { year: "2024", title: "EKIPTECH & KIPAY created", desc: "Technology and payments subsidiaries structured to complete the ecosystem." },
          { year: "2026", title: "EKIP Capital structured", desc: "Asset management platform put in place (AMF-UMOA licensing in progress)." },
        ],
      },
      governance: {
        eyebrow: "03 — Governance",
        title: "A committed team,",
        titleItalic: "clear principles.",
        team: [
          { name: "Ouagnimin SORHO", role: "Chairman & CEO", bio: "Founder and strategic architect of EKIP Holding Company. Pan-African vision and rigorous execution." },
          { name: "Finance Directorate", role: "Group CFO", bio: "SPV structuring, investor relations and capital discipline." },
          { name: "Operations Directorate", role: "Group COO", bio: "Subsidiary coordination, structuring project execution and cross-business synergies." },
          { name: "Technology Directorate", role: "Group CTO", bio: "Constructive innovation, connected technologies and ecosystem platform." },
        ],
        principles: [
          { title: "Separation of powers", desc: "Clear governance between shareholders, board and management." },
          { title: "Transparency & Integrity", desc: "Institutional reporting, non-negotiable ethics." },
          { title: "Minority protection", desc: "Legal structuring that protects all investors." },
          { title: "OHADA compliance", desc: "Full alignment with regional legal standards." },
        ],
      },
      figures: {
        eyebrow: "04 — Key figures",
        title: "The measure",
        titleItalic: "of our ambition.",
        items: [
          { value: 5, suffix: "", label: "Operational subsidiaries" },
          { value: 4, suffix: "", label: "Structuring projects" },
          { value: 1000, suffix: "+", label: "Jobs projected by 2030" },
          { value: 8, suffix: "", label: "Urban hubs" },
        ],
      },
    },
    ecosysteme: {
      hero: {
        overline: "Ecosystem",
        title: "The integrated ecosystem",
        titleItalic: "of modern life.",
        subtitle: "Four businesses. One network. One unified client experience.",
      },
      schema: {
        eyebrow: "01 — Ecosystem map",
        title: "Click a subsidiary",
        titleItalic: "to reveal its synergies.",
        holdingLabel: "Holding",
        synergyLabel: "Synergy",
      },
      synergies: {
        title: "Six concrete synergies.",
        items: [
          { from: "KIDH", to: "Kip Energy", desc: "Wayne stations integrated into KIDH neighborhoods." },
          { from: "KIDH", to: "EKIPTECH", desc: "Smart buildings, IoT and residential home automation." },
          { from: "KIDH", to: "KIPAY", desc: "Cashless payments and co-branded mortgage products." },
          { from: "Kip Energy", to: "EKIPTECH", desc: "Tech boutiques integrated in Wayne stations." },
          { from: "Kip Energy", to: "KIPAY", desc: "Digital payment for fuel and lubricants." },
          { from: "EKIPTECH", to: "KIPAY", desc: "Connected IoT payment solutions." },
        ],
      },
    },
    projets: {
      hero: {
        overline: "Structuring projects",
        title: "Projects that",
        titleItalic: "transform Côte d'Ivoire.",
        subtitle: "Infrastructure, housing, tourism — the developments shaping the future.",
      },
      map: {
        eyebrow: "01 — Map",
        title: "A footprint",
        titleItalic: "at national scale.",
        legend: {
          immobilier: "Real Estate",
          energie: "Energy",
          tourisme: "Tourism",
          infrastructure: "Infrastructure",
        },
      },
      list: {
        eyebrow: "02 — Flagship projects",
        title: "Four developments,",
        titleItalic: "one ambition.",
      },
      cta: {
        title: "Join these structuring projects.",
        subtitle: "Institutional investors, strategic partners or public institutions — let's talk.",
        button: "Become a partner",
      },
    },
    impact: {
      hero: {
        overline: "Impact",
        title: "Impact,",
        titleItalic: "beyond the numbers.",
        subtitle: "Jobs created, affordable housing, energy deployed, communities served.",
      },
      stats: {
        eyebrow: "01 — Social & economic impact",
        title: "A tangible",
        titleItalic: "contribution.",
        items: [
          { value: 1000, suffix: "+", label: "Jobs projected by 2030" },
          { value: 60000, suffix: "", label: "Homes planned" },
          { value: 100, suffix: "", label: "Wayne stations" },
          { value: 8, suffix: "", label: "Urban hubs" },
          { value: 300000, suffix: "", label: "People housed at scale" },
          { value: 47000, suffix: "", label: "Vision 2035 jobs" },
        ],
      },
      odd: {
        eyebrow: "02 — Sustainable Development Goals",
        title: "Aligned with",
        titleItalic: "the UN SDGs.",
        items: [
          { code: "SDG 7", title: "Affordable and clean energy" },
          { code: "SDG 8", title: "Decent work and economic growth" },
          { code: "SDG 9", title: "Industry, innovation and infrastructure" },
          { code: "SDG 11", title: "Sustainable cities and communities" },
          { code: "SDG 17", title: "Partnerships for the goals" },
        ],
      },
      innovation: {
        eyebrow: "03 — Constructive innovation",
        title: "Build",
        titleItalic: "better, faster, fairer.",
        text: "Our technical approach — EPS panels, tunnel formwork, light steel framing — enables a 33 to 40% cost reduction versus traditional methods. A direct impact on housing affordability in Côte d'Ivoire.",
        stats: [
          { value: 40, suffix: "%", label: "Cost reduction vs traditional methods" },
          { value: 3, suffix: "x", label: "Faster construction speed" },
          { value: 100, suffix: "%", label: "Compliant with international standards" },
        ],
      },
      territorial: {
        eyebrow: "04 — Territorial engagement",
        title: "Rooted",
        titleItalic: "in local communities.",
        items: [
          { title: "Traditional chieftaincies", desc: "Systematic consultation with customary authorities before every project." },
          { title: "Vocational training", desc: "Qualification programs in construction, energy and digital trades." },
          { title: "Local subcontracting", desc: "Priority given to Ivorian SMEs for site execution." },
        ],
      },
    },
    actualites: {
      hero: {
        overline: "News",
        title: "Our press releases,",
        titleItalic: "publications and events.",
      },
      categories: {
        all: "All",
        communique: "Press releases",
        media: "Media",
        evenement: "Events",
        publication: "Publications",
      },
      empty: "No news for now.",
    },
    carrieres: {
      hero: {
        overline: "Careers",
        title: "Join those who",
        titleItalic: "build tomorrow's Africa.",
        subtitle: "We recruit the talents who will grow EKIP Holding and its subsidiaries.",
      },
      why: {
        eyebrow: "01 — Why EKIP",
        title: "An employer",
        titleItalic: "up to your ambitions.",
        pillars: [
          { title: "Continental-scale projects", desc: "Take part in structuring projects for Côte d'Ivoire and West Africa." },
          { title: "Exponential growth", desc: "From 25 to 650 team members projected by 2030 — fast career opportunities." },
          { title: "International training", desc: "Development programs in partnership with African and international groups." },
          { title: "Flagship projects", desc: "Vision 2035, Wayne Network, Sassandra Resort — work on projects that matter." },
        ],
      },
      offers: {
        eyebrow: "02 — Open positions",
        title: "Positions",
        titleItalic: "we are hiring.",
        filterEntity: "Subsidiary",
        filterType: "Type",
        all: "All",
        apply: "Apply",
        items: [
          { title: "Managing Director KIDH", entity: "KIDH", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Head of Stations Network", entity: "Kip Energy", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Lead Product Manager IoT", entity: "EKIPTECH", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Growth Manager Wallet", entity: "KIPAY", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Analyst Corporate Finance", entity: "EKIP Capital", location: "Abidjan", type: "CDI", date: "Dec. 2026" },
          { title: "Construction Project Manager", entity: "KIDH", location: "Grand-Bassam", type: "CDD", date: "Dec. 2026" },
        ],
      },
      spontaneous: {
        eyebrow: "03 — Open application",
        title: "Your talent",
        titleItalic: "interests us.",
        subtitle: "Send us your profile, even without a matching current opening.",
        firstName: "First name",
        lastName: "Last name",
        email: "Business email",
        phone: "Phone",
        subsidiary: "Subsidiary of interest",
        cvLabel: "Resume (PDF)",
        cvChoose: "Choose a file",
        motivation: "Cover letter",
        submit: "Send my application",
      },
    },
    contact: {
      hero: {
        overline: "Contact",
        title: "Let's discuss",
        titleItalic: "your ambitions.",
        subtitle: "Investors, partners, institutions or media — our teams reply within 48h.",
      },
      general: {
        eyebrow: "01 — General form",
        title: "Write to us.",
        name: "Full name",
        email: "Email",
        subject: "Subject",
        subjects: [
          "General information",
          "Partnership",
          "Investment",
          "Press",
          "Recruitment",
          "Other",
        ],
        message: "Your message",
      },
      investors: {
        eyebrow: "02 — Investor relations",
        title: "A dedicated",
        titleItalic: "institutional contact.",
        subtitle: "IFC, Proparco, BOAD, AfDB, family offices, sovereign funds — one gateway.",
        organization: "Organization",
        role: "Role",
        investorType: "Investor type",
        types: ["DFI", "Investment fund", "Family office", "Sovereign fund", "Bank", "Other"],
        note: "Message",
      },
      coords: {
        eyebrow: "03 — Coordinates",
        title: "Visit us.",
        addressLabel: "Headquarters",
        address: ["Rue K104, Blvd Latrille", "Cocody II Plateaux", "Abidjan, Côte d'Ivoire"],
        emailLabel: "Email",
        emails: ["contact@ekipholding.ci", "investors@ekipholding.ci"],
        phoneLabel: "Phone",
        phones: ["+225 27 22 41 25 25", "+225 05 06 06 55 06"],
      },
    },
    footer: {
      about: "EKIP Holding Company — an integrated operational ecosystem based in Abidjan, Côte d'Ivoire.",
      columns: {
        group: "Group",
        ecosystem: "Ecosystem",
        projects: "Projects",
        contact: "Contact",
      },
      legal: "Legal notice",
      privacy: "Privacy policy",
      sitemap: "Sitemap",
      copyright: "© 2026 EKIP Holding Company. All rights reserved.",
      newsletter: "Receive our institutional press releases.",
      newsletterCta: "Subscribe",
    },
  },
};
